import { handleResponse } from "../utils/handle-response";

export const reportesServiceProyecto = {
    proyectosGeneral,
    proyectosGeneralCompanyId,
    proyectosGeneralCompanyFilter,
    proyectosGeneralCompanyFilter2,
    proyectosGeneralCompanyFilter3,
    calidadTipoInstalacion,

}

function sortArrays(a, b) {
    let compareA = a.id
    let compareB = a.id
    return compareA - compareB
}

function proyectosGeneral(filterParams) {
    const url = process.env.API_URL + "/api/v1/reportes/completitud-calidad-proyecto/"
    
    return fetch(url)
            .then(handleResponse)
            .then( x => {
                var re = new RegExp(filterParams.filter.search)
                x = x.filter( y => {
                    const { nup } = y 
                    return re.test(nup)
                })
                let totalResults = x.length
                x.sort(sortArrays)
                x = x.slice(filterParams.pagination.perPage * filterParams.pagination.page - filterParams.pagination.perPage, filterParams.pagination.perPage * filterParams.pagination.page)
                return Promise.resolve({ proyectos: x, totalResults });
            }).catch((error)=>{
               return Promise.reject(error)    
    }); 
}


function proyectosGeneralCompanyId(id) {
    const url = process.env.API_URL + "/api/v1/reportes/completitud-calidad-proyecto/?proyecto_id=" + id
    
    return fetch(url)
            .then(handleResponse)
            .then( x => {
                x.sort(sortArrays)
                return Promise.resolve({ proyectos: x, totalResults: 1 });
            }).catch((error)=>{
               return Promise.reject(error)    
    }); 
}

function proyectosGeneralCompanyFilter(filterParams) {
    const url = process.env.API_URL + "/api/v1/reportes/completitud-calidad-proyecto/"
    
    return fetch(url)
            .then(handleResponse)
            .then( x => {
                x.sort(sortArrays)
                return Promise.resolve({ proyectos: x });
            }).catch((error)=>{
               return Promise.reject(error)    
    }); 
}

function proyectosGeneralCompanyFilter2(id) {
    const url = process.env.API_URL + "/api/v1/reportes/completitud-calidad-empresa-proyecto/?proyecto_id=" + id
        
    return fetch(url)
            .then(handleResponse)
            .then( x => {
            x.sort(sortArrays)
                return Promise.resolve({ proyectosCompany: x });
            }).catch((error)=>{
                return Promise.reject(error)
        });
}

function proyectosGeneralCompanyFilter3(id, filterParams) {
    const url = process.env.API_URL + "/api/v1/reportes/completitud-calidad-instalacion-proyecto/?proyecto_id=" + id
    
    return fetch(url)
            .then(handleResponse)
            .then( x => {
                let insTotalResults = x.length
                x.sort(sortArrays)
                x = x.slice(filterParams.pagination.perPage * filterParams.pagination.page - filterParams.pagination.perPage, filterParams.pagination.perPage * filterParams.pagination.page)
                return Promise.resolve({ proyectosInstalaciones: x, insTotalResults });
            }).catch((error)=>{
               return Promise.reject(error)    
    }); 
}

function calidadTipoInstalacion(idProyecto) {
    const url = idProyecto   ? process.env.API_URL + "/api/v1/reportes/calidad-tipo-instalacion-general-proyecto/?proyecto_id=" + idProyecto 
                            : process.env.API_URL + "/api/v1/reportes/calidad-tipo-instalacion-general-proyecto/"
    return fetch(url)
            .then(handleResponse)
            .then( dataSetTipoInstalacion => {
                return Promise.resolve( dataSetTipoInstalacion )
            })
}